import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import CopyToClipboard from 'react-copy-to-clipboard';
import QRCode from 'qrcode.react';
import Utils from 'libs/Utils';
import PropTypes from 'prop-types';

import Header from 'components/Header';
import FloatingBalloon from 'components/FloatingBalloon';
import ToolTip from 'components/ToolTip';
import OrderInformation from 'components/OrderInformation';
import PairUnavailable from 'scenes/PairUnavailable';

import './styles.css';
import copy from './img/copy.svg';
import tooltip from './img/tooltip.svg';

class NoDeposits extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      pairNotFound: false,
    };
  }

  componentWillMount() {
    this.props.infoStore.setPair(
      this.props.exchangeStore.exchange.fromCoin,
      this.props.exchangeStore.exchange.toCoin,
      (error) => {
        if (error === 'This coin pair could not be found') return this.setState({ pairNotFound: true });
        return this.setState({ error });
      },
    );
  }

  render() {
    if (this.state.pairNotFound) return (<PairUnavailable />);

    let fromBigIcon;
    switch (this.props.exchangeStore.exchange.fromCoin.iconType) {
      case 'vector':
        fromBigIcon = (
          <img
            className="title__icon"
            src={this.props.exchangeStore.exchange.fromCoin.iconUrl}
            alt={`${this.props.exchangeStore.exchange.fromCoin.name} (${this.props.exchangeStore.exchange.fromCoin.symbol}) icon`}
            width="36"
            height="36"
          />
        );
        break;
      case 'pixel':
        fromBigIcon = (
          <img
            className="title__icon"
            src={`${this.props.exchangeStore.exchange.fromCoin.iconUrl}?size=72`}
            alt={`${this.props.exchangeStore.exchange.fromCoin.name} (${this.props.exchangeStore.exchange.fromCoin.symbol}) icon`}
            width="36"
            height="36"
          />
        );
        break;
      default:
        fromBigIcon = (
          <span className="title__icon title__icon--placeholder" />
        );
    }

    const toAmount = (
      (this.props.exchangeStore.exchange.fromAmount *
      this.props.infoStore.rate) - this.props.infoStore.minerFee
    );

    return (
      <div className="no-deposits">
        {this.state.error ?
          <div className="error">{this.state.error} <Link className="error__link" to="/">Click here to go back</Link></div>
        : null}

        <Header step={2} light />
        <div className="content">
          <h1 className="title">Send {fromBigIcon} {this.props.exchangeStore.exchange.fromCoin.name} to address</h1>

          <div className="destination">
            <div className="destination__split">
              <div className="destination__form-control">
                <div className="destination__label">
                  {this.props.exchangeStore.exchange.fromCoin.symbol} amount
                </div>
                <div className="destination__input">
                  <div className="destination__value destination__value--big">{Utils.coinNumberFormat(this.props.exchangeStore.exchange.fromAmount, '?')}</div>
                  <div className="destination__action">
                    <FloatingBalloon text="Copied">
                      <CopyToClipboard
                        text={this.props.exchangeStore.exchange.fromAmount}
                      >
                        <div className="destination__copy">
                          <img className="destination__copy-img" src={copy} width="18" height="20" alt="Copy" />
                        </div>
                      </CopyToClipboard>
                    </FloatingBalloon>
                  </div>
                </div>
              </div>

              <div className="destination__qrcode">
                <QRCode value={this.props.exchangeStore.exchange.exchangeAddress} size={90} fgColor="#02162b" bgColor="#ebf2f9" />
              </div>
            </div>

            <div className="destination__form-control">
              <div className="destination__label">
                To address
              </div>
              <div className="destination__input">
                <div className="destination__value">{this.props.exchangeStore.exchange.exchangeAddress}</div>
                <div className="destination__action">
                  <FloatingBalloon text="Copied">
                    <CopyToClipboard
                      text={this.props.exchangeStore.exchange.exchangeAddress}
                    >
                      <div className="destination__copy">
                        <img className="destination__copy-img" src={copy} width="18" height="20" alt="Copy" />
                      </div>
                    </CopyToClipboard>
                  </FloatingBalloon>
                </div>
              </div>
            </div>
            {this.props.exchangeStore.exchange.fromCoin.exchangeExtraId ?
              <div className="destination__form-control">
                <div className="destination__label">
                  {this.props.exchangeStore.exchange.fromCoin.extraIdName}
                  <ToolTip text={`A ${this.props.exchangeStore.exchange.fromCoin.extraIdName} acts like a payment reference. Make sure to include this in your transaction, or you will lose your coins.`}>
                    <img className="destination__information" src={tooltip} width="15" height="15" alt="Tooltip" />
                  </ToolTip>
                  <span className="destination__warning">Don&#39;t forget this!</span>
                </div>
                <div className="destination__input">
                  <div className="destination__value">{this.props.exchangeStore.exchange.exchangeExtraId}</div>
                  <div className="destination__action">
                    <FloatingBalloon text="Copied">
                      <CopyToClipboard
                        text={this.props.exchangeStore.exchange.exchangeExtraId}
                      >
                        <div className="destination__copy">
                          <img className="destination__copy-img" src={copy} width="18" height="20" alt="Copy" />
                        </div>
                      </CopyToClipboard>
                    </FloatingBalloon>
                  </div>
                </div>
              </div>
            : null}

            <div className="waiting">
              <span className="waiting__spinner" />
              <span className="waiting__description">
                Waiting for your transaction <span className="waiting__confirmations">0 confirmations</span>
              </span>
            </div>
          </div>

          <div className="estimate">
            <span className="estimate__pulsate" />
            {`Approximately ${Utils.coinNumberFormat(toAmount, 2)} ${this.props.exchangeStore.exchange.toCoin.name} will be sent to your wallet.`}
          </div>

          <OrderInformation exchangeStore={this.props.exchangeStore} />
        </div>
      </div>
    );
  }
}

NoDeposits.propTypes = {
  exchangeStore: PropTypes.object.isRequired,
  infoStore: PropTypes.object.isRequired,
};

export default NoDeposits;



// WEBPACK FOOTER //
// ./src/scenes/Exchange/scenes/NoDeposits/index.jsx